import { paths } from '@/util/paths';

export const Modes = {
  EXPLORE: {
    name: 'EXPLORE', // All
    url: paths.explore,
    apiCall: 'explore',
  },
  CONTACT_DIRECTORY: {
    name: 'CONTACT_DIRECTORY',
    url: paths.contactDirectory,
  },
  INBOX: {
    name: 'INBOX', // All except the archived
    url: paths.tendersInbox,
    apiCall: 'received',
  },
  OPPORTUNITIES: {
    name: 'OPPORTUNITIES', // My Opportunities
    url: paths.opportunities,
  },
  BUSINESS_INTELLIGENCE: {
    name: 'BUSINESS_INTELLIGENCE', // Business Intelligence
    url: paths.businessIntelligence,
  },
};
